import { OwnerGuideEntry } from "../../../../components/ownerOnboarding/entry";
import { Link } from "react-router-dom";
import {
  FiBookOpen,
  FiShoppingBag,
  FiUsers,
  FiCreditCard,
  FiSettings,
  FiHelpCircle,
} from "react-icons/fi";
import "./style.css";
const guides = [
  {
    title: "Carta y productos",
    icon: FiBookOpen,
    description: "Organiza los productos y decide dónde se publican.",
    steps: [
      "Crea el producto con su nombre y precio; se guarda inicialmente en borrador.",
      "Asigna sus categorías y catálogos desde Organización del producto.",
      "Revisa alérgenos, extras y variantes antes de publicarlo.",
    ],
    path: "/products",
    action: "Ir a productos",
  },
  {
    title: "Gestión de pedidos",
    icon: FiShoppingBag,
    description: "Consulta estados, pagos y detalles de cada pedido.",
    steps: [
      "Busca el pedido por su número o cliente.",
      "Filtra por canal y estado del pago para acotar el listado.",
      "Abre la ficha para revisar productos, importes y cronología.",
    ],
    path: "/orders",
    action: "Ir a pedidos",
  },
  {
    title: "Tu equipo y el TPV",
    icon: FiUsers,
    description: "Distingue el acceso a la plataforma del PIN personal.",
    steps: [
      "El acceso general desbloquea la plataforma del negocio.",
      "Después, cada empleado entra con su PIN personal y los permisos asignados.",
      "Los perfiles de Punto de venta determinan los usuarios y canales disponibles.",
    ],
    path: "/configuration#101",
    action: "Ver usuarios y permisos",
  },
  {
    title: "Pagos y entrega",
    icon: FiCreditCard,
    description: "Configura cómo se cobra y cómo se recibe un pedido.",
    steps: [
      "Revisa los métodos de pago y entrega en Configuración.",
      "En cada canal elige cuáles están admitidos.",
      "Guarda los cambios y comprueba el canal correspondiente.",
    ],
    path: "/salesChannel",
    action: "Ver canales de venta",
  },
  {
    title: "Identidad de tu negocio",
    icon: FiSettings,
    description: "Logo, icono de la app, colores y apariencia de la tienda.",
    steps: [
      "Sube el logo principal, el logo de ticket y el favicon en Diseño.",
      "Elige el color de marca y la distribución de la carta.",
      "Guarda y revisa la tienda para comprobar el resultado.",
    ],
    path: "/configuration#108",
    action: "Abrir Diseño",
  },
  {
    title: "Información para soporte",
    icon: FiHelpCircle,
    description: "Prepara los datos que ayudan a localizar una incidencia.",
    steps: [
      "Anota la pantalla y los pasos que provocan el problema.",
      "Incluye el número de pedido o el nombre del producto cuando corresponda.",
      "Acompaña la descripción con una captura; evita incluir contraseñas o PIN.",
    ],
  },
];
export const Help = () => (
  <>
    <div className="topContainer">
      <div className="pageHeading">
        <h1 className="bodyTitle">Ayuda</h1>
        <p>Guías rápidas para trabajar con tu negocio.</p>
      </div>
    </div>
    <OwnerGuideEntry compact />
    <div className="adminHelpGrid">
      {guides.map((guide) => (
        <article key={guide.title}>
          <span className="adminHelpIcon">
            <guide.icon aria-hidden="true" />
          </span>
          <h2>{guide.title}</h2>
          <p>{guide.description}</p>
          <details>
            <summary>Ver los pasos</summary>
            <ol>
              {guide.steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          </details>
          {guide.path && <Link to={guide.path}>{guide.action} →</Link>}
        </article>
      ))}
    </div>
  </>
);
